import moment from "moment-timezone";

const weekdayNames = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
]


const findTalkDateAndTime = (startTime, duration) => {
  if (!startTime) return null;

  const timeStart = new Date(startTime);
  const timeEnd = moment(timeStart)
    .add(duration, "m")
    .toDate();
  const start = moment(timeStart).tz('Europe/Oslo').format("HH:mm");
  const end = moment(timeEnd).tz('Europe/Oslo').format("HH:mm");
  const day = weekdayNames[timeEnd.getDay()];

  return {
    day,
    start,
    end
  }
}

export default findTalkDateAndTime;
